"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_2 = require("@emotion/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var recoil_1 = require("recoil");
var unescape_1 = __importDefault(require("lodash-es/unescape"));
var components_1 = require("@/components");
var Styled = __importStar(require("./ApplicationDetailView.styled"));
var date_1 = require("@/utils/date");
var ApplicationDetail_1 = require("@/components/ApplicationDetail");
var store_1 = require("@/store");
var constants_1 = require("@/constants");
var api = __importStar(require("@/api"));
var hooks_1 = require("@/hooks");
var ApplicationDetailView = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var id = (0, react_router_dom_1.useParams)().id;
    var data = (0, recoil_1.useRecoilValue)((0, store_1.$applicationById)({ applicationId: id }));
    var handleGoBack = (0, hooks_1.useHistory)().handleGoBack;
    (0, react_3.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!id) {
                            throw Error();
                        }
                        if (!!data) return [3 /*break*/, 2];
                        return [4 /*yield*/, api.getApplicationById({ applicationId: id })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        navigate(constants_1.PATH.FORBIDDEN);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [data, id, navigate]);
    return ((0, jsx_runtime_1.jsxs)(Styled.ApplicationDetailViewPage, { children: [(0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsx)(components_1.BackButton, { label: "\uBAA9\uB85D \uB3CC\uC544\uAC00\uAE30", onClick: function () { return handleGoBack(constants_1.PATH.APPLICATION); } }, void 0), (0, jsx_runtime_1.jsx)(Styled.Headline, { children: "\uC9C0\uC6D0\uC124\uBB38\uC9C0 \uC0C1\uC138" }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("article", { children: [(0, jsx_runtime_1.jsxs)(Styled.ApplicantInfo, { children: [(0, jsx_runtime_1.jsx)("h3", { children: "\uC778\uC801\uC815\uBCF4" }, void 0), (0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(ApplicationDetail_1.TitleWithContent, __assign({ title: "\uC774\uB984" }, { children: (0, unescape_1.default)(data.applicant.name) }), void 0), (0, jsx_runtime_1.jsx)(ApplicationDetail_1.TitleWithContent, __assign({ title: "\uC774\uBA54\uC77C" }, { children: data.applicant.email }), void 0), (0, jsx_runtime_1.jsx)(ApplicationDetail_1.TitleWithContent, __assign({ title: "\uAC70\uC8FC\uC9C0\uC5ED" }, { children: (0, unescape_1.default)(data.applicant.residence) }), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(ApplicationDetail_1.TitleWithContent, __assign({ title: "\uC804\uD654\uBC88\uD638" }, { children: data.applicant.phoneNumber }), void 0), (0, jsx_runtime_1.jsx)(ApplicationDetail_1.TitleWithContent, __assign({ title: "\uC0DD\uB144\uC6D4\uC77C" }, { children: data.applicant.birthdate }), void 0), (0, jsx_runtime_1.jsx)(ApplicationDetail_1.TitleWithContent, __assign({ title: "\uC18C\uC18D" }, { children: (0, unescape_1.default)(data.applicant.department) }), void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(Styled.Divider, {}, void 0), (0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ApplicationDetail_1.TitleWithContent, __assign({ title: "\uC9C0\uC6D0\uD50C\uB7AB\uD3FC" }, { children: data.team.name }), void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ApplicationDetail_1.TitleWithContent, __assign({ title: "\uC9C0\uC6D0\uC77C\uC2DC" }, { children: (0, date_1.formatDate)(data.submittedAt, 'YYYY년 M월 D일(ddd)') }), void 0) }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.QuestionList, { children: [(0, jsx_runtime_1.jsx)("h3", { children: "\uC9C8\uBB38 \uB9AC\uC2A4\uD2B8" }, void 0), (0, jsx_runtime_1.jsx)("section", { children: data === null || data === void 0 ? void 0 : data.questions.map(function (each, index) { return ((0, react_1.createElement)(ApplicationDetail_1.ApplicationQnAItem, __assign({}, each, { answer: data === null || data === void 0 ? void 0 : data.answers[index], key: each.questionId }))); }) }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.Aside, { children: [(0, jsx_runtime_1.jsx)(ApplicationDetail_1.ApplicationPanel, { confirmationStatus: data.confirmationStatus, resultStatus: data.result.status, interviewDate: data.result.interviewStartedAt, applicationId: id }, void 0), (0, jsx_runtime_1.jsx)(ApplicationDetail_1.MessageListPanel, { application: data }, void 0)] }, void 0)] }, void 0)] }, void 0));
};
exports.default = ApplicationDetailView;
